import request from '@/config/axios'
import { asCapacityPage, type CapacityPageResult } from '@/api/capacity/page'

export interface CompensationTicket {
  ticketId: string
  waybillId: string
  externalId?: string
  riderPhone?: string
  amount: number
  reason: string
  status: string
  actorId?: string
  createdAt?: string
}

export interface ActResult {
  success: boolean
  message?: string
}

export const listCompensate = async (params?: {
  pageNo?: number
  pageSize?: number
}): Promise<CapacityPageResult<CompensationTicket>> => {
  const raw = await request.get({ url: '/capacity/platform/compensate/list', params })
  return asCapacityPage<CompensationTicket>(raw, params?.pageNo, params?.pageSize)
}

export const createCompensate = (params: {
  waybillId: string
  amount: number
  reason?: string
  cancelWaybill?: boolean
}) =>
  request.post<ActResult>({ url: '/capacity/platform/compensate/create', params })

export const markCompensatePaid = (ticketId: string) =>
  request.post<ActResult>({
    url: '/capacity/platform/compensate/mark-paid',
    params: { ticketId }
  })
